import { CssBaseline } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { createRouter } from './app/router';
import { BrandThemeProvider } from './app/BrandTheme';
import { NotifyProvider } from './components/NotifyProvider';
import { AuthProvider } from './features/auth/AuthProvider';
import { createQueryClient } from './lib/queryClient';

const queryClient = createQueryClient();
const router = createRouter();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrandThemeProvider>
        <CssBaseline />
        <NotifyProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </NotifyProvider>
      </BrandThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
